/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Inbox_NInputs */

const en_tut_inbox_n = /** @type {(inputs: Tut_Inbox_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muting a single channel happens in that channel, from the bell menu: **Semua pesan**, **Hanya mention**, or **Bisu**.`)
};

const id_tut_inbox_n = /** @type {(inputs: Tut_Inbox_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membisukan satu channel diatur di channel itu sendiri lewat menu lonceng: **Semua pesan**, **Hanya mention**, atau **Bisu**.`)
};

/**
* | output |
* | --- |
* | "Muting a single channel happens in that channel, from the bell menu: **Semua pesan**, **Hanya mention**, or **Bisu**." |
*
* @param {Tut_Inbox_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_inbox_n = /** @type {((inputs?: Tut_Inbox_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Inbox_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_inbox_n(inputs)
	return en_tut_inbox_n(inputs)
});